export interface qrVideUrl {
  id: any
  qrCodeUrl: any
  videoUrl: any
}

export interface qrProps {
  data: qrVideUrl
}

export interface InitialState {
  isLoading: boolean
  setSelectedQrId: any
  getQrData: qrProps
}

export const initialState: InitialState = {
  isLoading: false,
  setSelectedQrId: ' ',
  getQrData: {
    data: {
      id: '',
      videoUrl: '',
      qrCodeUrl: ''
    }
  }
}
